export function italianToIso(value) {
  const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value || "");
  if (!match) return null;
  const [, day, month, year] = match;
  const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.getUTCFullYear() !== Number(year)
      || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day)) return null;
  return `${year}-${month}-${day}`;
}

export function todayItalian(date = new Date()) {
  return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" })
    .format(date).replaceAll("/", "-");
}

export function missingSuggestions(plan) {
  return (plan?.suggestions || []).filter((item) => !item.auto_lot && item.blocked_reason);
}

export function supplierOptions(suppliers, ingredientId) {
  return suppliers.filter((supplier) => supplier.active !== false && (supplier.ingredient_ids || []).includes(ingredientId));
}

export function prepareRecipeLots(rows, siteId, documents = []) {
  const errors = {};
  const lots = Object.entries(rows).map(([ingredientId, row]) => {
    const receivedDate = italianToIso(row.received_date);
    const expiryDate = italianToIso(row.expiry_date);
    const missing = [];
    if (!row.supplier_id) missing.push("fornitore");
    if (!row.supplier_lot?.trim()) missing.push("lotto prodotto");
    if (!receivedDate) missing.push("data acquisto");
    if (!expiryDate) missing.push("data scadenza");
    if (missing.length) errors[ingredientId] = missing;
    return { ingredient_id: ingredientId, site_id: siteId, supplier_id: row.supplier_id,
      supplier_lot: row.supplier_lot?.trim().toUpperCase(), received_date: receivedDate,
      expiry_date: expiryDate, product_code: row.product_code?.trim().toUpperCase() || "", documents };
  });
  return { lots, errors };
}

// Una riga è "iniziata" quando l'utente ha scritto qualcosa di suo: data di
// acquisto (precompilata a oggi) e fornitore (precompilato se unico) non contano.
export function isRowStarted(row) {
  return Boolean(row?.supplier_lot?.trim() || row?.expiry_date?.trim() || row?.product_code?.trim());
}

// Salvataggio parziale: restituisce solo i lotti completi; le righe iniziate ma
// incomplete finiscono in errors, quelle mai toccate vengono semplicemente saltate.
export function splitRecipeLots(rows, siteId, documents = []) {
  const started = Object.fromEntries(Object.entries(rows).filter(([, row]) => isRowStarted(row)));
  const { lots, errors } = prepareRecipeLots(started, siteId, documents);
  return { lots: lots.filter((lot) => !errors[lot.ingredient_id]), errors };
}
